import { Server, Database, Shield, Archive, Cloud, Lock, Zap } from "lucide-react";
import { PortalLayout } from "../components/PortalLayout";

const services = [
  { icon: Server, title: "Dedicated & Virtual Server Hosting", desc: "Flexible server environments for any workload." },
  { icon: Database, title: "Application & Database Hosting", desc: "Managed hosting for apps, APIs, and databases." },
  { icon: Shield, title: "Secure Data Storage & Processing", desc: "High-throughput environments with access controls." },
  { icon: Archive, title: "Backup & Disaster Recovery", desc: "Automated backups with defined RTOs and RPOs." },
  { icon: Cloud, title: "Offsite & Managed Data Backups", desc: "Secure offsite backup for external data protection." },
  { icon: Lock, title: "Firewall & Network Security", desc: "Enterprise firewall and intrusion detection." },
  { icon: Zap, title: "High-Availability Infrastructure", desc: "Redundant, always-on mission-critical environments." },
];

export function InfrastructurePage() {
  return (
    <PortalLayout>

      {/* Header */}
      <div className="mb-14">
        <p className="text-xs font-semibold uppercase tracking-widest text-[#7B1A1A] mb-4">
          Infrastructure & Hosting Services — Primary Revenue Driver
        </p>
        <h1 className="text-2xl sm:text-4xl md:text-5xl font-semibold text-[#1F2933] mb-8 leading-tight max-w-3xl">
          Enterprise Infrastructure. Professionally Managed.
        </h1>
        <p className="text-[#4B5563] max-w-4xl leading-relaxed">
          LEO Group provides enterprise-grade infrastructure solutions to businesses requiring secure, scalable, and
          reliable hosting environments. These services are designed to support both internal platforms and external
          clients, enabling organisations to deploy and manage systems without the complexity of maintaining their
          own infrastructure.
        </p>
      </div>

      {/* Stats */}
      <div className="grid md:grid-cols-3 gap-6 mb-14">
        {[
          { value: "99.9%", label: "Uptime SLA" },
          { value: "24/7", label: "Monitoring & Support" },
          { value: "ISO", label: "Aligned Security" },
        ].map((stat) => (
          <div key={stat.label} className="bg-white border border-[#E5E7EB] rounded-lg p-8 text-center shadow-sm">
            <p className="text-3xl font-semibold text-[#7B1A1A] mb-2">{stat.value}</p>
            <p className="text-sm text-[#4B5563]">{stat.label}</p>
          </div>
        ))}
      </div>

      {/* Built for Mission-Critical */}
      <div className="mb-14">
        <h2 className="text-xl font-semibold text-[#1F2933] mb-4">Built for Mission-Critical Operations</h2>
        <p className="text-[#4B5563] leading-relaxed max-w-3xl mb-6">
          Our infrastructure layer is engineered for continuous reliability, data integrity, and operational continuity
          at scale. All environments are monitored, redundant, and designed to meet enterprise-grade availability requirements.
        </p>
        <div className="bg-[#FDEAE0]/60 border border-[#7B1A1A]/15 rounded-lg p-6">
          <p className="text-[#4B5563] leading-relaxed text-sm">
            Businesses can deploy, host, and scale their systems within LEO Group's secure, professionally managed
            infrastructure environment.
          </p>
        </div>
      </div>

      {/* Services */}
      <div className="mb-14">
        <h2 className="text-xl font-semibold text-[#1F2933] mb-8">Core Service Offerings</h2>
        <div className="space-y-3">
          {services.map(({ icon: Icon, title, desc }) => (
            <div key={title} className="bg-white border border-[#E5E7EB] rounded-lg p-5 flex gap-4 shadow-sm">
              <Icon className="w-5 h-5 text-[#7B1A1A] flex-shrink-0 mt-0.5" />
              <div>
                <h3 className="text-sm font-semibold text-[#1F2933] mb-1">{title}</h3>
                <p className="text-sm text-[#4B5563]">{desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>


    </PortalLayout>
  );
}
